import { render, staticRenderFns } from "./HomeForFamiliesService.vue?vue&type=template&id=d49a18b6&scoped=true&lang=pug"
import script from "./HomeForFamiliesService.vue?vue&type=script&lang=ts"
export * from "./HomeForFamiliesService.vue?vue&type=script&lang=ts"
import style0 from "./HomeForFamiliesService.vue?vue&type=style&index=0&id=d49a18b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49a18b6",
  null
  
)

export default component.exports